'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createPaginationItems = require('./createPaginationItems');

var _createPaginationItems2 = _interopRequireDefault(_createPaginationItems);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _createPaginationItems2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/dist/commonjs/lib/createPaginationItems/index.js
 ** module id = 1299
 ** module chunks = 0
 **/